// @ts-check

import React from "react";
import "../styles/DonorCard.css";
import { transformCampaignName } from "./CampaignList";

/**
 *  @typedef {import('./coreTypes').JSLegacyDonorData} JSLegacyDonorData
 *  @typedef {import('./coreTypes').JSX} JSX
 */

/**
 * @param {{donor: JSLegacyDonorData}} props 
 * @returns {JSX | null}
 */
function LegacyDonorCard(props) {
	var heightOffset = 0;

	try {
		if (props.donor.campaigns === null) return null;

		if (props.donor.campaigns.length === 0) return null;

		let commentBlock = null;

		if (props.donor.campaignComments[props.donor.campaigns[0]] !== undefined) {
			const comments = 
				props.donor.campaignComments[props.donor.campaigns[0]].map(c => (<p>{c}</p>));
			commentBlock = (<><p/><div className="donor-campaign-comment-container">{comments}</div></>);

			comments.forEach(element => {
				heightOffset = heightOffset + 10;
			});
		}

		const campaigns = 
			(<ul className="donor-campaigns"><li>{transformCampaignName(props.donor.campaigns[0])}{commentBlock}</li></ul>);
		
		var blockSizeToPixels;
		if (props.donor.blockSize === 1)
			blockSizeToPixels = (/** @type {number} */ b) => (b * 88 + (b-1) * 20);
		else if (props.donor.blockSize === 2)
			blockSizeToPixels = (/** @type {number} */ b) => (b * 88 + (b-1) * 20);
		else if (props.donor.blockSize === 3)
			blockSizeToPixels = (/** @type {number} */ b) => (b * 88 + (b-1) * 20);
		else if (props.donor.blockSize === 4)
			blockSizeToPixels = (/** @type {number} */ b) => (b * 60 + (b-1) * 20);
		else
			blockSizeToPixels = (/** @type {number} */ b) => (b * 65 + (b-1) * 20);
	
		const styling = { 
			height: blockSizeToPixels(props.donor.blockSize) + 'px'
		};
	
		return (
			<div className="donor-card" style={styling}>
					<div className="donor-name-container">
					<h4 className="donor-name">{props.donor.firstName} {props.donor.lastName}</h4>
					<p className="donor-class-of">Legacy Donor (1971-90)</p>
				</div>
				<div className="donor-card-line"></div>
				{campaigns}
				</div>);
				
	} catch (e) {
		return null;
	}
}

export default LegacyDonorCard;